/**
 * @file utility.service.ts
 * @module to set of function for utility purpose
 * @author Aniket
 */
import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { MatSnackBar } from '@angular/material';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ClipboardService } from 'ngx-clipboard';

@Injectable()
export class UtilityService {

    constructor(private snackbar: MatSnackBar, 
                private spinnerService: Ng4LoadingSpinnerService,
                private clipboardService: ClipboardService) { }
    uigrid_to_sheet(data, columns) {
        var o = [],
            oo = [],
            i = 0,
            j = 0;

        /* column headers */
        for (j = 0; j < columns.length; ++j) oo.push(columns[j]);
        o.push(oo);

        /* table data */
        for (i = 0; i < data.length; ++i) {
            oo = [];
            for (j = 0; j < data[i].length; ++j) oo.push(data[i][j]);
            // Object.keys(data).forEach(key=>{
            //     oo.push(data[i][key]);
            // });
            o.push(oo);
        }
        /* aoa_to_sheet converts an array of arrays into a worksheet object */
        return XLSX.utils.aoa_to_sheet(o);
    }

    openSnackBar(message: string) {
        this.snackbar.open(message, null, {
            duration: 3000,
        });
    }
    showSpinner() {
        this.spinnerService.show();
    }

    hideSpinner() {
        this.spinnerService.hide();
    }

    copyToClipBoard(data){
        this.clipboardService.copyFromContent(data);   
    }
}
